<script setup lang="ts">
import { ModalCollection } from '~/constants'
import Modal from '~common/modal.vue'
import { EVENT } from '~/configs/page-url'
import { useEventEntryHalloween } from '~/composables/events/halloween/use-event-entry'
import { useDayTimeEvent } from '~/composables/events/halloween/use-day-time-event'

useHead({
  link: [
    {
      rel: 'preload',
      as: 'image',
      href: '/assets/images/events/halloween/event-entry/new-bg-event-entry.webp',
      type: 'image/webp',
      fetchpriority: 'high',
    },
  ],
})

const { initModal, closeModalEvent, navigateToEventRanking } = useEventEntryHalloween()
const { dayTimeEvent } = useDayTimeEvent()
const { isMobile } = useDevice()
const curvePath = isMobile ? 'M 30,70 Q 300,0 570,70' : 'M 30,70 Q 300,-20 570,70'

onMounted(() => {
  initModal()
})
</script>

<template>
  <Modal
    :modalId="ModalCollection.HALLOWEEN_EVENT_ENTRY"
    :isShowIconClose="false"
    :isClickBackdropClose="false"
    modalClass="event-entry-popup"
    :modalContentClasses="isMobile ? 'event-entry-popup__content mobile' : 'event-entry-popup__content'"
  >
    <div class="event-entry-popup__content-wrap">
      <div class="button-close" @click="closeModalEvent">
        <img src="/assets/images/events/halloween/event-entry/icon-close.webp" alt="close" />
      </div>

      <NuxtLink :to="EVENT.HALLOWEEN" class="image-welcome" @click="navigateToEventRanking">
        <div class="event-entry-popup-wrap">
          <img src="/assets/images/events/halloween/event-entry/new-bg-event-entry.webp" alt="event halloween" />
        </div>
        <div class="text-wrapper">
          <!-- SVG text overlay -->
          <svg class="curved-text-svg" viewBox="0 0 600 80" preserveAspectRatio="xMidYMid meet">
            <defs>
              <path id="textCurve" :d="curvePath" fill="transparent"/>
              <linearGradient id="textGradient" x1="0%" y1="0%" x2="100%" y2="0%" gradientUnits="objectBoundingBox">
                <stop offset="10.46%" style="stop-color:#fffecb; stop-opacity:1" />
                <stop offset="112.11%" style="stop-color:#ffde70; stop-opacity:1" />
              </linearGradient>
            </defs>
            <text>
              <textPath href="#textCurve" startOffset="50%" text-anchor="middle">
                Thời gian diễn ra | 
                <tspan class="date-highlight">{{ dayTimeEvent.rangeDateInfo }}</tspan>
              </textPath>
            </text>
          </svg>
        </div>
      </NuxtLink>
    </div>
  </Modal>
</template>

<style lang="scss">
@import '~/assets/scss/components/common/event/halloween/event-entry.scss';
</style>
